// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + chunkId + "." + {"1581": "233a8345f459d273","3091": "3dd21f3e6383e7fc",}[chunkId] + ".css"
}